import { useQuery } from '@tanstack/react-query';

import { queryFn } from './queryFn';

export const QUERY_KEY = 'LEARNING_CONTENT' as const;

export function useLearningHub({ contentKey }: { contentKey: string }) {
  return useQuery({
    queryKey: [QUERY_KEY, contentKey],
    queryFn,
    retry: 1,
    staleTime: 3600000,
  });
}
